import React from 'react';
import { Button, Typography } from '@material-ui/core';
import UserTableBlankBase from './UserTableBlankBase';
import EmailReports from '../static/EmailReports';
function UserTableErrorState(_a) {
    var onClick = _a.onClick;
    return (React.createElement(UserTableBlankBase, { image: React.createElement(EmailReports, null), message: React.createElement("div", null,
            React.createElement(Typography, { variant: "body1" }, "Unable to load licenses"),
            React.createElement(Button, { variant: "text", color: "primary", onClick: onClick }, "Retry")) }));
}
export default UserTableErrorState;
//# sourceMappingURL=UserTableErrorState.js.map